import { api } from "@/services/api"
import { queryClient } from "@/queryClient"
import type { RetrieveCurrentUserResponse } from "./retrieveCurrentUser"

export const handleLogInLink = async (params: {
  token: string
}) => {
  const { body } =
    await api.post<RetrieveCurrentUserResponse>(
      "/handle-login-link-session/",
      {
        body: params,
      }
    )

  // Note if return shape of handle-log-link-session and whoami diverge this needs changing to a invliadateQueries
  queryClient.setQueryData([CURRENT_USER_QUERY_KEY], body)

  return body
}
